import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PreguntasFrecuentesForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["PreguntasFrecuentes"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.pregunta}>            
                              <label  >{strings?strings["pregunta"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["pregunta"]:""} 
                                    name="pregunta"
                                    onChange={onChange}
                                    value={datos.pregunta}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.respuesta}>            
                              <label  >{strings?strings["respuesta"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["respuesta"]:""} 
                                    name="respuesta"
                                    onChange={onChange}
                                    value={datos.respuesta}
                                    icon='edit'/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/preguntasfrecuentess">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default PreguntasFrecuentesForm;